import { Ref, computed } from 'vue';

import { EBillingPlanCode } from '@/contexts/billingContext/domain/constants';
import { useTenantsStore } from '@/stores/tenants';

type TUseView = {
  isPublicOfferAccept: Ref<boolean>,
  isManyEmployeesAlertShown: Ref<boolean>,
  isEmailConfirmed: Ref<boolean>,
  planCode: Ref<EBillingPlanCode | null>,
};

export const useView = ({
  isPublicOfferAccept,
  isManyEmployeesAlertShown,
  isEmailConfirmed,
  planCode,
}: TUseView,
) => {
  const tenantsStore = useTenantsStore();
  const isSubmitDisabled = computed(() => !isPublicOfferAccept.value
  || isManyEmployeesAlertShown.value
  || !isEmailConfirmed.value);

  const hasActiveSubscription = computed(() => !!tenantsStore.getActiveSubscription);

  const hasPastSubscriptions = computed(() => !!tenantsStore.currentTenantDetails?.hasPastSubscriptions);

  const isBillingTrialPeriodInfoShown = computed(
    () => !hasPastSubscriptions.value
    && !hasActiveSubscription.value
    && planCode.value !== EBillingPlanCode.carrierStart,
  );

  return {
    isSubmitDisabled,
    isBillingTrialPeriodInfoShown,
  };
};
